import { defineEntity, lifecycle } from './_helpers.js';

export default defineEntity('control', {
    reviewDue: lifecycle(),
});
